import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=24fb0685&scoped=true&"
import script from "./ProductCenter.vue?vue&type=script&lang=ts&"
export * from "./ProductCenter.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=24fb0685&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb0685",
  null
  
)

export default component.exports